<template>
  <m-dialog ref="cekDataDlg" :btnsave="false" title="Validasi KTA">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="12" lg="10" xl="7">
        <v-alert border="top" v-if="countWarga > 0" colored-border type="error" elevation="2">
          Mohon perhatikan ada {{ countWarga }} Anggota yang belum memenuhi syarat <b>Generate Nomor KTA</b>. <br />
          <div class="py-2">Anda bisa melengkapi data dengan menekan tombol Lengkapi.</div>
          <div class="py-2">
            Setelah melengkapi data, tekan tombol refresh untuk memperbarui status validasi data.
          </div>
        </v-alert>
        <v-alert border="top" v-else colored-border type="info" elevation="2"> Data Anggota Anda lengkap, silakan tekan tombol Generate </v-alert>
        <v-card>
          <v-card-text>
            <v-row v-for="warga in wargaValidate" :key="warga.index">
              <v-col cols="12" sm="2" md="1" lg="1">
                <p class="py-0 my-0 primary--text">NIK</p>
                {{ pVal(warga, "nik") }}
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3">
                <p class="py-0 my-0 primary--text">Nama</p>
                {{ pVal(warga, "nama") }}
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4">
                <p class="py-0 my-0 primary--text">Keterangan</p>
                <p class="red--text" v-for="pesan in warga.message_lengkap" :key="pesan.index">{{ pesan }}</p>
              </v-col>
              <v-col cols="12" sm="1" md="2" lg="2">
                <div align="right" class="ma-1">
                  <v-btn block :small="$vuetify.breakpoint.smAndDown" depressed color="info" @click="lengkapi(warga)">
                    Lengkapi Data
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="12" sm="12" md="3" lg="3">
                <div align="right" class="ma-1">
                  <v-btn class="my-2" block :small="$vuetify.breakpoint.smAndDown" depressed color="success" @click="cekData()">
                    Refresh Data
                  </v-btn>
                  <v-btn class="my-2" block :disabled="countWarga > 0" :small="$vuetify.breakpoint.smAndDown" depressed color="info" @click="generate()">
                    Generate KTA
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { SIM } from "@/const";
// Basic Use - Covers most scenarios
export default {
  data() {
    return {
      wargaValidate: null,
      countWarga: 0,
      kotaid: null
    };
  },
  methods: {
    // eslint-disable-next-line
    open(kotaid) {
      this.kotaid = kotaid;
      this.cekData();
      let x = this.$refs.cekDataDlg.open();
      this.$validator.reset();
      this.isReset = true;
      this.$nextTick(() => {
        this.isReset = false;
      });
      return x;
    },
    lengkapi(item) {
      window.open(SIM + "/#/warga/" + item.id, "_blank");
    },
    generate() {
      var obj = {
        kota_id: this.kotaid
      };
      this.$store
        .dispatch("warga/generateNomorMasal", obj)
        .then(res => {
          if (res.error) {
            this.$error(res.message);
            this.loading = false;
          } else {
            this.loading = false;
            this.$info("Generate nomor KTA masal berhasil");
            this.load();
          }
        })
        .catch(e => e);
    },
    cekData() {
      this.$store
        .dispatch("warga/cekData", this.kotaid)
        .then(res => {
          this.countWarga = res.total_tidak_lengkap;
          this.wargaValidate = res.data;
        })
        .catch(e => e);
    }
  }
};
</script>
